module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00039.6c58b3f8.jpg";